import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { addAccount, getAccountDetail, getAccountList, getSampleFile, removeAccount, validatePublicReq } from '../actions/accountAction';

interface AccountState {
    loading: boolean;
    accountInfo: any; // Define the type of userInfo
    error: any; // De
    success: boolean;
    loading1: boolean;
    addAccInfo: any;
    error1: any;
    success1: boolean;
    loading2: boolean;
    rmvAccInfo: any;
    success2: boolean;
    error2: any;
    loading3: boolean;
    error3: any;
    success3: boolean;
    invAccountInfo: any;
    loading4:boolean;
    success4:boolean;
    tokenInfo:any;
    error4:any;
    loading5:boolean;
    error5:any;
    success5:boolean;
    sfileInfo:any;
}

const initialState: AccountState = {
    loading: false,
    accountInfo: null,
    error: null,
    success: false,
    loading1: false,
    error1: null,
    success1: false,
    addAccInfo: null,
    loading2: false,
    error2: null,
    success2: false,
    rmvAccInfo: null,
    loading3: false,
    error3: null,
    success3: false,
    invAccountInfo: null,
    loading4:false,
    error4:null,
    tokenInfo:null,
    success4:false,
    loading5:false,
    error5:null,
    success5:false,
    sfileInfo:null,
}

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(getAccountList.pending, (state: any) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.accountInfo = null;
            })
            .addCase(getAccountList.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.loading = false;
                state.accountInfo = action.payload;
                state.success = true;
            })
            .addCase(getAccountList.rejected, (state: any, action: PayloadAction<any>) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            })
            .addCase(addAccount.pending, (state: any) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.addAccInfo = null;
            })
            .addCase(addAccount.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.loading1 = false;
                state.addAccInfo = action.payload;
                state.success1 = true;
            })
            .addCase(addAccount.rejected, (state: any, action: PayloadAction<any>) => {
                state.loading1 = false;
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(removeAccount.pending, (state: any) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.rmvAccInfo = null;
            })
            .addCase(removeAccount.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.loading2 = false;
                state.rmvAccInfo = action.payload;
                state.success2 = true;
            })
            .addCase(removeAccount.rejected, (state: any, action: PayloadAction<any>) => {
                state.loading2 = false;
                state.error2 = action.payload;
                state.success2 = false;
            })
            .addCase(getAccountDetail.pending, (state: any) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
                state.invAccountInfo = null;
            })
            .addCase(getAccountDetail.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.loading3 = false;
                state.invAccountInfo = action.payload;
                state.success3 = true;
            })
            .addCase(getAccountDetail.rejected, (state: any, action: PayloadAction<any>) => {
                state.loading3 = false;
                state.error3 = action.payload;
                state.success3 = false;
            })
            .addCase(validatePublicReq.pending, (state: any) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
                state.tokenInfo = null;
            })
            .addCase(validatePublicReq.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.loading4 = false;
                state.tokenInfo = action.payload;
                state.success4 = true;
            })
            .addCase(validatePublicReq.rejected, (state: any, action: PayloadAction<any>) => {
                state.loading4 = false;
                state.error4 = action.payload;
                state.success4 = false;
            })
            .addCase(getSampleFile.pending, (state: any) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
                state.sfileInfo = null;
            })
            .addCase(getSampleFile.fulfilled, (state: any, action: PayloadAction<any>) => {
                state.loading5 = false;
                state.sfileInfo = action.payload;
                state.success5 = true;
            })
            .addCase(getSampleFile.rejected, (state: any, action: PayloadAction<any>) => {
                state.loading5 = false;
                state.error5 = action.payload;
                state.success5 = false;
            });
    }
});

export default accountSlice.reducer;